import { T_R } from '../constants';
import type { TRElement } from '../types';
import { createTD } from './createTD';

/** Create a TR element */
export const createTR = (children: TRElement['children'] = [createTD()]): TRElement => {
    return { type: T_R, children };
};
